import UserInfo from '../userInfo'
import UserInfoItem from '../userInfoItem'
import {
    AccountWrap,
    InfoDetail,
    AccountTitle
} from './accountElements'
import { useSelector } from 'react-redux'
import { BorderLine } from '../../home/homeElements'

const Account = () => {
    const { user } = useSelector(state => state.user)
    return (
        <AccountWrap>
            <UserInfo large />
            <BorderLine className='hide-on-pc' style={{marginTop: '15px'}} />
            <AccountTitle>Thông tin tài khoản</AccountTitle>
            <InfoDetail>
                {!user.facebookId && !user.googleId && <UserInfoItem field='username' label='Họ và tên' text={user.username}/>}
                <UserInfoItem field='phone' label='Số điện thoại' text={user.phone ? user.phone : 'Chưa có'} number />
                <UserInfoItem field='gender' label='Giới tính' text={user.gender} select options={
                    [{ value: 'Nam', label: 'Nam' },
                    { value: 'Nữ', label: 'Nữ' },
                    { value: 'Không xác định', label: 'Không xác định' }]
                } />
            </InfoDetail>
            {!user.facebookId && !user.googleId &&
                <>
                    <BorderLine style={{ marginTop: '40px', marginLeft: '-15px' }} />
                    <AccountTitle>Bảo mật</AccountTitle>
                    <UserInfoItem field='password' password label='Mật khẩu' text={`*********`}/>
                </>
            }
        </AccountWrap>
    )
}

export default Account
